module.exports = __webpack_public_path__ + "static/media/plus.665bd18e.svg";